import React from 'react';

type ToastProps = {
  notification: { message: string; type?: 'success' | 'error' | 'info' } | null;
  onClose: () => void;
};

export const Toast: React.FC<ToastProps> = ({ notification, onClose }) => {
  if (!notification) return null;

  return (
    <div className="fixed top-4 right-4 z-50">
      <div
        role="status"
        aria-live="polite"
        className={`px-4 py-2 rounded shadow text-sm font-medium flex items-center gap-3 ${
          notification.type === 'success'
            ? 'bg-green-600 text-white'
            : notification.type === 'error'
              ? 'bg-red-600 text-white'
              : 'bg-blue-600 text-white'
        }`}
      >
        <span>{notification.message}</span>
        <button
          onClick={onClose}
          aria-label="Close notification"
          className="ml-2 opacity-80 hover:opacity-100"
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default Toast;
